import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  Pagination
} from "../../../../../../_metronic/_partials/controls";
import { sizePerPageList } from "../OrganizationUIHelpers";
import FileSaver from "file-saver";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  fetchOrganization,
  fetchOrganizationFiles,
  refereshReduxState,
  rejectOrganization,
  reUploadOrgDocs,
  updateSimpzStatus
} from "../../../_redux/organization/organizationAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toAbsoluteUrl,
  toastOption
} from "../../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import ConfirmationDeleteModal from "../../../../Project/pages/modal-for-project/ConfirmationDeleteModal";
import { toast } from "react-toastify";
import OrganizationActivatedModal from "../organization-activated-modal/OrganizationActivatedModal";
import {
  ORGANIZATION_FILE_TYPE,
  SIMPZ_STATUS
} from "../../../../../config/helper";
import ReUploadOrgModal from "./ReUploadOrgModal";
import LoadingAnimation from "../../../../Donation/pages/import-donation/loading-animation/LoadingAnimation";
import { RoleChecker } from "../../../../../RoleChecker";

export default function OrganizationFiles({
  match: {
    params: { id }
  },
  history
}) {
  // * DECLARE HOOK
  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    organization_uuid: id
  });
  const [confirmationModal, setConfirmationModal] = useState({
    activated: false,
    inactive: false,
    reject: false,
    reUploadDocs: false
  });

  const dispatch = useDispatch();

  const { currentState } = useSelector(
    state => ({ currentState: state.superAdminOrganization }),
    shallowEqual
  );

  const {
    totalCount,
    organizationFiles,
    listLoading,
    actionsLoading,
    organizationForEdit = {}
  } = currentState;

  useEffect(() => {
    dispatch(refereshReduxState());
    dispatch(fetchOrganization(id));
  }, []);

  useEffect(() => {
    if (
      organizationForEdit &&
      ["SUBMIT", "ACTIVE"].includes(organizationForEdit.simpz_status)
    ) {
      dispatch(fetchOrganizationFiles(queryParams));
    }
  }, [organizationForEdit, queryParams]);

  function capitalizeFirstLetter(string) {
    string = string.toLowerCase().replace("_", " ");
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const getFolderLabel = label => {
    let str;
    switch (label) {
      case ORGANIZATION_FILE_TYPE.ID_CARD:
        str = "KTP";
        break;
      case ORGANIZATION_FILE_TYPE.FINANCIAL_STATEMENTS:
        str = "Laporan keuangan 1 tahun terakhir";
        break;
      case ORGANIZATION_FILE_TYPE.AGREEMENT:
        str = "Form pemahaman dan persetujuan";
        break;
      case ORGANIZATION_FILE_TYPE.PARTNER_PROFILE:
        str = "Form profil mitra";
        break;
      case ORGANIZATION_FILE_TYPE.OTHERS:
        str = "Dokumen lainnya";
        break;
      case ORGANIZATION_FILE_TYPE.MLHR:
        str = "SK Kemenkumham";
        break;

      default:
        str = capitalizeFirstLetter(label);
        break;
    }
    return str;
  };

  const columns = [
    // {
    //   dataField: "file",
    //   text: "Dokumen",
    //   formatter: cell => {
    //     if (cell) {
    //       const link = cell.storage + "/" + cell.path;
    //       return (
    //         <a
    //           class="link-primary text-primary"
    //           onClick={() => FileSaver.saveAs(link, cell.filename)}
    //           style={{ textDecoration: "underline" }}
    //         >
    //           Download
    //         </a>
    //       );
    //     }
    //   }
    // },
    {
      dataField: "caption",
      text: "Nama File"
    },
    {
      dataField: "type",
      text: "Tipe",
      formatter: cell => {
        return <span>{getFolderLabel(cell)}</span>;
      }
    },
    {
      formatter: (cell, row) => {
        return (
          <>
            <OverlayTrigger
              overlay={
                <Tooltip id="products-edit-tooltip">Lihat Dokumen</Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-info btn-sm mr-3"
                href={`${row.file.storage}/${row.file.path}`}
                target="_blank"
              >
                <span className="svg-icon svg-icon-md svg-icon-info">
                  <i className="fa fa-eye"></i>
                </span>
              </a>
            </OverlayTrigger>
          </>
        );
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  const updateMpzStatus = values => {
    dispatch(updateSimpzStatus({ ...values, organization_uuid: id })).then(
      res => {
        dispatch(fetchOrganization(id));
        dispatch(fetchOrganizationFiles(queryParams));
        setConfirmationModal(false);
        toast.success("Berhasil update MPZ!", toastOption);
      }
    );
  };

  const cardTitle = () => {
    return (
      <div>
        <span>Dokumen Lembaga</span>
        <span
          style={{ marginLeft: "10px" }}
          className={`label label-lg label-light-${
            organizationForEdit.simpz_status == SIMPZ_STATUS.ACTIVE
              ? "success"
              : "danger"
          } label-inline`}
        >
          {organizationForEdit.simpz_status == SIMPZ_STATUS.ACTIVE
            ? "DOKUMEN DITERIMA"
            : "LEMBAGA BELUM AKTIF"}
        </span>
      </div>
    );
  };

  const handleHideModal = () => {
    setConfirmationModal({
      activated: false,
      inactive: false,
      reject: false,
      reUploadDocs: false
    });
  };

  const handleOpenModal = key => {
    setConfirmationModal(prev => ({
      ...prev,
      [key]: true
    }));
  };

  const onSaveReUploadDocs = payload => {
    const data = {
      ...payload,
      organization_uuid: id
    };
    dispatch(reUploadOrgDocs(data)).then(res => {
      if (res.status === 200) {
        handleHideModal();
        history.goBack();
        toast.success(res.data.message, toastOption);
      } else {
        toast.error(res.data.message, toastOption);
      }
    });
  };

  const handleRejectOrganization = () => {
    dispatch(
      rejectOrganization({ organization_uuid: organizationForEdit.uuid })
    ).then(res => {
      if (res.status === 200) {
        handleHideModal();
        history.goBack();
        toast.success(res.data.message, toastOption);
      } else {
        toast.error(res.data.message, toastOption);
      }
    });
  };

  const allowEdit = RoleChecker("Edit", "organization");
  const allowApprove = RoleChecker("Approval", "organization");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <ReUploadOrgModal
        show={confirmationModal.reUploadDocs}
        onHide={handleHideModal}
        onSave={onSaveReUploadDocs}
      />
      <OrganizationActivatedModal
        title={`${
          organizationForEdit.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${organizationForEdit.name}`}
        show={confirmationModal.activated}
        onHide={handleHideModal}
        onClick={updateMpzStatus}
        initialValues={{
          is_activated: true,
          end_date: organizationForEdit.end_date,
          organization_classification_uuid:
            organizationForEdit.organization_classification &&
            organizationForEdit.organization_classification.uuid,
          organization_classification_name:
            organizationForEdit.organization_classification &&
            organizationForEdit.organization_classification.name,
          status: SIMPZ_STATUS.ACTIVE
        }}
      />
      {/* Confirmation Disable Org Modal */}
      <ConfirmationDeleteModal
        title={`${
          organizationForEdit.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${organizationForEdit.name}`}
        show={confirmationModal.inactive}
        onHide={handleHideModal}
        content={`Apakah anda yakin ingin ${
          organizationForEdit.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${organizationForEdit.name}?`}
        onClick={() =>
          updateMpzStatus({
            is_activated: false
          })
        }
      />
      {/* Confirmation Reject Docs Modal */}
      <ConfirmationDeleteModal
        title={`Tolak lembaga menjadi MPZ`}
        show={confirmationModal.reject}
        onHide={handleHideModal}
        content={`Apakah anda yakin ingin menolak lembaga menjadi MPZ? Lempbaga yang ditolak tidak dapat mengakses SIMPZ kembali!`}
        onClick={() => handleRejectOrganization()}
      />
      <Card>
        <CardHeader title={cardTitle()}>
          <CardHeaderToolbar>
            {organizationFiles.length !== 0 && (
              <>
                {organizationForEdit.simpz_status === SIMPZ_STATUS.SUBMIT && (
                  <>
                    {allowApprove && (
                      <>
                        <button
                          className="btn btn-outline-dark mr-4"
                          onClick={() => handleOpenModal("reUploadDocs")}
                        >
                          Lengkapi Dokumen
                        </button>
                        <button
                          className="btn btn-outline-danger mr-4"
                          onClick={() => handleOpenModal("reject")}
                        >
                          Tolak Lembaga
                        </button>
                      </>
                    )}
                  </>
                )}
                {allowEdit && (
                  <button
                    className="btn btn-outline-info mr-4"
                    onClick={() => {
                      if (organizationForEdit.is_activated) {
                        handleOpenModal("inactive");
                      } else {
                        handleOpenModal("activated");
                      }
                    }}
                  >
                    {organizationForEdit.is_activated
                      ? "Non Aktifkan MPZ"
                      : "Aktifkan MPZ"}
                  </button>
                )}
              </>
            )}
            <button
              className="btn btn-secondary"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <>
            <PaginationProvider
              pagination={paginationFactory(paginationOptions)}
            >
              {({ paginationProps, paginationTableProps }) => {
                return (
                  <Pagination
                    isLoading={listLoading}
                    paginationProps={paginationProps}
                  >
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      bordered={false}
                      remote
                      keyField="uuid"
                      data={organizationFiles === null ? [] : organizationFiles}
                      columns={columns}
                      onTableChange={getHandlerTableChange(setQueryParams)}
                      {...paginationTableProps}
                    >
                      <PleaseWaitMessage entities={organizationFiles} />
                      <NoRecordsFoundMessage entities={organizationFiles} />
                    </BootstrapTable>
                  </Pagination>
                );
              }}
            </PaginationProvider>
          </>
        </CardBody>
      </Card>
    </>
  );
}
